module.exports = __webpack_public_path__ + "static/media/git.1780e08b.png";